import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { msalInstance } from '../authConfig';
import { logout_request } from '../services/for_allServices';

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// === Cookie Helpers ===
const setCookie = (name, value, days = 7) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
};

const deleteCookie = (name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};

// === Axios Interceptor : injecte le Bearer Token depuis le cookie ===
axios.interceptors.request.use((config) => {
    const token = getCookie('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {

    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkUser = async () => {
        const token = getCookie('auth_token');
        if (!token) { setUser(null); setLoading(false); return; }

        /* try {
             const { data } = await axios.get('/api/user');
             setUser(data.user ? data.user : data); 
         } catch (error) {
             deleteCookie('auth_token');
             setUser(null);
         } finally {
             setLoading(false);
         }*/
        setLoading(false);
    };

    useEffect(() => {
        checkUser();
    }, []);

    const logout = async () => {
            console.log("deleted !!!!");
        try {
            if (getCookie('auth_token')) await logout_request();
        } catch (error) {
            console.error('Logout failed', error);
        } finally {
            console.log("deleted !!!!");
            sessionStorage.clear();
            localStorage.clear();
            deleteCookie('auth_token');
            setUser(null);
            // Effacer le cache MSAL pour forcer une re-authentification Microsoft
            const accounts = msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                await msalInstance.logoutPopup({
                    account: accounts[0],
                    mainWindowRedirectUri: '/login'
                });
            }
            window.dispatchEvent(new Event("storage"));
        }
    };

    const value = { user, loading, checkUser, logout, setCookie, getCookie, deleteCookie };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};